import { sortListByPosition } from '@/lib/util';

const displayableInsights = {
  content_types: 1,
  agencies: 2,
  capabilities: 3,
  topics: 4,
  tags: 5,
  regions: 6,
  countries: 7,
  clients: 8,
  brands: 9,
  partners: 10,
  tools: 11,
  industries: 12,
  sub_industries: 13,
  target_markets: 14,
  keywords: 15,
};

const isDisplayableInsight = (facet) => {
  if (facet.values?.length <= 0) {
    return false;
  }

  if (facet.facetCategory.toLowerCase().startsWith('auto')) {
    return !facet.name.startsWith('Indexer ');
  }

  return facet.key in displayableInsights;
};

const facetCategories = [
  'Standard Tags',
  'Auto Tags: Documents & Images',
  'Auto Tags: Videos',
];

class FacetInsightsList {
  facets = [];

  insights = [];

  constructor(facets) {
    this.facets = facets;
    this.setInsights();
  }

  setInsights() {
    const valueExtractor = (facet) => facet.key;
    const nonEmptyFacets = this.facets.filter(isDisplayableInsight);

    const facetNames = Object.keys(displayableInsights);
    this.insights = sortListByPosition(nonEmptyFacets)(facetNames)(valueExtractor);
  }

  get groupedInsights() {
    return facetCategories
      .map((category) => ({
        name: category,
        list: this.insights.filter((facet) => facet.facetCategory === category),
      }));
  }
}

export default FacetInsightsList;
